export default __webpack_public_path__ + "static/media/cavaleiro.f281d6ac.png";